/**
 * Browser compatibility polyfills and fixes
 */

// Fix for the mozInputSource deprecation warning
if (typeof MouseEvent !== 'undefined' && MouseEvent.prototype) {
  // Only apply in Firefox which has this property
  if ('mozInputSource' in MouseEvent.prototype) {
    Object.defineProperty(MouseEvent.prototype, 'mozInputSource', {
      get() {
        // This is a silent no-op that prevents the warning
        return undefined;
      },
      configurable: true
    });
  }
}

export {};